import React from "react";
import AboutYouChild from "../../components/common/create-profile/about-you";
import CreateProfileLayout from "../layout";
const AboutYou = () => {
  return (
    <CreateProfileLayout>
      <AboutYouChild />
    </CreateProfileLayout>
  );
};

export default AboutYou;
